import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { Logo } from "../components/Brand";
import { BackButton } from "../lib/nav";
import { toast } from "sonner";

const inp = "w-full bg-[#0A0A0C] border border-[#27272A] rounded-lg px-4 py-3 text-sm outline-none focus:border-[#E8552A]";
const Shell = ({ title, sub, children }) => (
  <div className="min-h-screen bg-[#0A0A0C] text-[#F4F4F5] flex items-center justify-center px-4">
    <div className="w-full max-w-md card-copper rounded-2xl p-8 fade-up">
      <Logo size={40} /><BackButton fallback="/login" className="mt-6" />
      <h1 className="font-display text-2xl font-bold uppercase mt-3">{title}</h1>
      <p className="mono-label text-[#71717A] mt-1">{sub}</p>
      {children}
    </div>
  </div>
);

export function ForgotPassword() {
  const [email, setEmail] = useState(""); const [sent, setSent] = useState(false); const [busy, setBusy] = useState(false);
  const submit = async (e) => { e.preventDefault(); setBusy(true); try { await api.post("/auth/forgot-password", { email }); setSent(true); } catch (ex) { toast.error(formatApiError(ex.response?.data?.detail)); } setBusy(false); };
  return (
    <Shell title="Forgot password" sub="WE'LL EMAIL YOU A RESET LINK">
      {sent ? <p data-testid="forgot-sent" className="text-sm text-[#A1A1AA] mt-6">If an account exists for <b>{email}</b>, a reset link is on its way (valid 30 minutes). Check spam too.</p> : (
        <form onSubmit={submit} className="space-y-4 mt-6">
          <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" className={inp} />
          <button data-testid="forgot-submit" disabled={busy} className="w-full copper-btn rounded-lg py-3 mono-label disabled:opacity-60">{busy ? "SENDING…" : "SEND RESET LINK"}</button>
        </form>)}
      <p className="text-sm text-[#71717A] text-center mt-6"><Link to="/login" className="text-[#E8552A] hover:underline">Back to sign in</Link></p>
    </Shell>
  );
}

export function ResetPassword() {
  const [sp] = useSearchParams(); const nav = useNavigate();
  const [pw, setPw] = useState(""); const [pw2, setPw2] = useState(""); const [err, setErr] = useState(""); const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setErr("");
    if (pw !== pw2) { setErr("Passwords do not match"); return; }
    setBusy(true);
    try { await api.post("/auth/reset-password", { token: sp.get("token"), password: pw }); toast.success("Password updated — sign in"); nav("/login", { replace: true }); }
    catch (ex) { setErr(formatApiError(ex.response?.data?.detail)); }
    setBusy(false);
  };
  return (
    <Shell title="Set a new password" sub="MINIMUM 8 CHARACTERS">
      <form onSubmit={submit} className="space-y-4 mt-6">
        <input data-testid="reset-password" type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New password" className={inp} />
        <input data-testid="reset-password2" type="password" required value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="Repeat new password" className={inp} />
        {err && <p data-testid="reset-error" className="text-sm text-[#ef4444]">{err}</p>}
        <button data-testid="reset-submit" disabled={busy || !sp.get("token")} className="w-full copper-btn rounded-lg py-3 mono-label disabled:opacity-60">{busy ? "SAVING…" : "UPDATE PASSWORD"}</button>
      </form>
    </Shell>
  );
}

export function VerifyEmail() {
  const [sp] = useSearchParams(); const [state, setState] = useState("checking");
  useEffect(() => { api.post("/auth/verify-email", { token: sp.get("token") }).then(() => setState("ok")).catch(() => setState("bad")); }, [sp]);
  return (
    <Shell title="Email verification" sub={state === "ok" ? "VERIFIED" : state === "bad" ? "LINK INVALID OR EXPIRED" : "CHECKING…"}>
      <p data-testid="verify-state" className="text-sm text-[#A1A1AA] mt-6">{state === "ok" ? "Your email is verified. Thank you." : state === "bad" ? "Request a new verification email from your dashboard." : "One moment…"}</p>
      <p className="text-sm text-[#71717A] text-center mt-6"><Link to="/dashboard" className="text-[#E8552A] hover:underline">Go to dashboard</Link></p>
    </Shell>
  );
}
